import {useState} from "react";
import { GlobalVars } from "../../../state/global/globalVars";
import UilAngleUp from "@iconscout/react-unicons/icons/uil-angle-up";
import UilAngleDown from "@iconscout/react-unicons/icons/uil-angle-down";

export default function Section({ children, className, title, small, noBorder, noCollapse, background, ...rest }) {
    const [open, setOpen] = useState(true);

    return (
        <section className={`p-2 sm:p-4 shadow-sm ${noBorder ? "" : "border"} rounded ${className} ${background || "bg-light-11"}`} {...rest}>
            {(title || !noCollapse) &&
                <div className={`col-span-full flex justify-between items-center h-auto`}>
                    <div className="sm:font-semibold">{title}</div>
                    {(!noCollapse || (!open && !noCollapse)) &&
                        <button
                            className={`underline text-light-6 text-sm ${ open ? "lg:hidden" : "" } pr-1`}
                            onClick={() => setOpen(!open)}
                        >
                            {open ?
                                <UilAngleUp size={small ? GlobalVars.iconSize.md : GlobalVars.iconSize.xl} className="-m-2" />
                                :
                                <UilAngleDown size={small ? GlobalVars.iconSize.md : GlobalVars.iconSize.xl} className="-m-2" />
                            }
                        </button>
                    }
                </div>
            }
            {open && children}
        </section>
    );
}